import { Url } from '../shared/Url';
import Post from '../shared/Post';
import { cookieData } from '../funciones/ConsultaUser';


export const AlumnosXCarrera = (carrera, respuesta) => {
    cookieData((cookie) => {
        let Content = {
            uId: cookie[1],
            carrera: carrera
        }

        Post(`${Url}AlumnosXCarrera`, Content, (resp) => {
            let data = JSON.parse(resp)
            respuesta(data)
        });
    });
}

export const DatosRendimiento = (carrera, respuesta) => {
    cookieData((cookie) => {
        let Content = {
            uId: cookie[1],
            carrera: carrera
        }

        Post(`${Url}RendimientoData`, Content, (resp) => {
            let data = JSON.parse(resp)
            respuesta(data)
        });
    });
}

export const AlumnosXSemestre = (semestre, respuesta) => {
    cookieData((cookie) => {
        let Content = {
            uId: cookie[1],
            semestre: semestre
        }

        Post(`${Url}AlumnosXSemestre`, Content, (resp) => {
            let data = JSON.parse(resp)
            respuesta(data)
        });
    });
}

export const ConsultaSecciones = (semestre, respuesta) => {
    cookieData((cookie) => {
        let Content = {
            uId: cookie[1],
            semestre: semestre,
        }

        Post(`${Url}ConsultaSecciones`, Content, (resp) => {
            let data = JSON.parse(resp)
            respuesta(data[0])
        });
    });
}

export const SeccionesXSemestre = (seccion, respuesta) => {
    cookieData((cookie) => {
        let Content = {
            uId: cookie[1],
            seccion: seccion,
        }

        Post(`${Url}SeccionesXSemestre`, Content, (resp) => {
            let data = JSON.parse(resp)
            respuesta(data)
        });
    });
}


// WEBPACK FOOTER //
// ./src/funciones/functionEstadistica.jsx